import React from 'react';
import { motion } from 'framer-motion';

interface NavSectionProps {
  title: string;
  children: React.ReactNode;
}

const NavSection: React.FC<NavSectionProps> = ({ title, children }) => {
  if (!title) {
    return (
      <div className="py-4">
        <nav className="space-y-1">
          {children}
        </nav>
      </div>
    );
  }
  
  return (
    <div className="py-4">
      <motion.h3
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        className="px-4 mb-2 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider"
      >
        {title}
      </motion.h3>
      <nav className="space-y-1">
        {children}
      </nav>
    </div>
  );
};

export default NavSection;